module.exports = {
    "ikea-screen-xx-small": "320px",
    "ikea-screen-x-small": "480px",
    "ikea-screen-small": "768px",
    "ikea-screen-medium": "1024px",
    "ikea-screen-large": "1440px",
    "ikea-screen-x-large": "1920px"
};